/* MARAYA: one-shot cart offers, verified upgrades, and a single delegated listener. */
(function () {
  'use strict';
  function configFrom(raw) {
    return raw.map(function (b) {
      return { handle: b.handle, parts: (b.specs || '').split('|').filter(Boolean).map(function (s) {
        var p = s.split(':'); return { handle: p[0], id: Number(p[1]) };
      }) };
    });
  }
  function represented(item, config) {
    var handles = [item.handle];
    var bundle = config.find(function (b) { return b.handle === item.handle; });
    if (bundle) handles = handles.concat(bundle.parts.map(function (p) { return p.handle; }));
    if (item.handle === 'maraya-mini-ritual') {
      var mini = { 'dry oil': 'argan-dry-oil', 'black soap': 'black-soap', 'argan soap': 'argan-soap', 'body lotion': 'argan-body-lotion', 'body scrub': 'argan-body-scrub' };
      (item.variant_options || []).forEach(function (v) { var h = mini[String(v).trim().toLowerCase()]; if (h) handles.push(h); });
    }
    return handles;
  }
  function conflict(cart, handle, config, exceptKey) {
    var wanted = represented({ handle: handle }, config);
    return cart.items.some(function (item) {
      return item.key !== exceptKey && represented(item, config).some(function (h) { return wanted.indexOf(h) !== -1; });
    });
  }
  function cleanSource(item, offer) {
    return !!item && Number(item.variant_id || item.id) === offer.sourceId && item.quantity === 1 &&
      !item.selling_plan_allocation && Object.keys(item.properties || {}).length === 0 &&
      item.final_price === offer.sourcePrice && item.original_price === item.final_price;
  }
  function productRole(handle) {
    var roles = { 'black-soap': 'cleanse', 'argan-soap': 'cleanse', 'kessa-glove': 'exfoliate',
      'argan-body-scrub': 'exfoliate', 'argan-body-lotion': 'hydrate', 'argan-dry-oil': 'hydrate' };
    return roles[handle] || '';
  }
  function roleConflict(cart, offer, config, exceptKey) {
    if (offer.mode === 'add') {
      var representedHandles = cart.items.reduce(function (all, item) {
        return all.concat(represented(item, config));
      }, []);
      if (offer.handle === 'argan-dry-oil' && representedHandles.indexOf('marrakech-ritual-set') !== -1) return false;
      if (offer.handle === 'kessa-glove' && representedHandles.indexOf('fes-ritual-set') !== -1) return false;
    }
    var addedHandle = offer.handle;
    if (offer.mode === 'upgrade') {
      var bundle = config.find(function (b) { return b.handle === offer.handle; });
      var added = bundle && bundle.parts.find(function (p) { return p.id !== offer.sourceId; });
      addedHandle = added && added.handle;
    }
    var role = productRole(addedHandle);
    return !!role && cart.items.some(function (item) {
      return item.key !== exceptKey && represented(item, config).some(function (h) { return productRole(h) === role; });
    });
  }
  function eligible(cart, offer, config) {
    if (offer.currency && cart.currency && offer.currency !== cart.currency) return false;
    if (offer.mode === 'add') return !conflict(cart, offer.handle, config) && !roleConflict(cart, offer, config);
    var bundle = config.find(function (b) { return b.handle === offer.handle; });
    var source = cart.items.find(function (i) { return i.key === offer.sourceKey; });
    return !!bundle && bundle.parts.some(function (p) { return p.id === offer.sourceId; }) &&
      !(cart.total_discount > 0) && cleanSource(source, offer) && offer.price > offer.sourcePrice &&
      !conflict(cart, offer.handle, config, offer.sourceKey) && !roleConflict(cart, offer, config, offer.sourceKey);
  }
  function reviewError(message) { var e = new Error(message); e.review = true; return e; }
  function createService(request, rawConfig, options) {
    var config = configFrom(rawConfig);
    var sectionContext = { sections: ['cart-drawer', 'cart-count'], sections_url: (options && options.sectionUrl) || '/cart' };
    return async function perform(offer, token) {
      var attempted = false;
      function tagged(cart) {
        return cart.items.find(function (i) { return Number(i.variant_id || i.id) === offer.id && (i.properties || {})._maraya_cart_action === token; });
      }
      function sourceIn(cart) {
        var exact = cart.items.find(function (i) { return i.key === offer.sourceKey; });
        if (exact) return exact;
        var candidates = cart.items.filter(function (i) { return Number(i.variant_id || i.id) === offer.sourceId && Object.keys(i.properties || {}).length === 0 && !i.selling_plan_allocation; });
        return candidates.length === 1 ? candidates[0] : undefined;
      }
      function hasSource(cart) {
        return cart.items.some(function (i) { return i.key === offer.sourceKey || Number(i.variant_id || i.id) === offer.sourceId; });
      }
      try {
        // Independent preflight reads run together; post-add verification still catches cart races.
        var preflight = await Promise.all([request('cart.js'), request('products/' + encodeURIComponent(offer.handle) + '.js')]);
        var cart = preflight[0], product = preflight[1];
        if (!eligible(cart, offer, config)) throw new Error('Your cart has changed. Please review the refreshed offer.');
        var variant = product.variants.find(function (v) { return Number(v.id) === offer.id; });
        if (!variant || !variant.available) throw new Error('This option is currently unavailable. Your cart was not changed.');
        if (Number(variant.price) !== offer.price) throw new Error('The price has changed. Please review the refreshed offer.');
        attempted = true;
        var addResult = await request('cart/add.js', Object.assign({ items: [{ id: offer.id, quantity: 1, properties: { _maraya_cart_action: token } }] }, sectionContext));
        cart = await request('cart.js');
        var added = tagged(cart);
        if (!added || added.quantity !== 1) throw new Error('We could not confirm the added item.');
        if (Number(added.original_price) !== offer.price) throw new Error('The price changed while adding this option.');
        if (offer.mode === 'add') {
          if (conflict(cart, offer.handle, config, added.key) || roleConflict(cart, offer, config, added.key)) throw new Error('This ritual step is already included in your cart.');
          cart.sections = addResult.sections;
          // A parallel cart edit/discount can make add-response fragments older than this verified cart.
          var rendered = cart.sections && cart.sections['cart-drawer'];
          var snapshotTotal = rendered && rendered.match(/data-mr-cart-total="(\d+)"/);
          var snapshotCount = rendered && rendered.match(/data-item-count="(\d+)"/);
          if (snapshotTotal && snapshotCount && (Number(snapshotTotal[1]) !== cart.total_price || Number(snapshotCount[1]) !== cart.item_count)) cart.sections = null;
          return cart;
        }
        var source = sourceIn(cart);
        if (!cleanSource(source, offer)) throw new Error('Your original item changed during the upgrade.');
        var otherItems = { items: cart.items.filter(function (i) { return i.key !== source.key; }) };
        if (conflict(otherItems, offer.handle, config, added.key) || roleConflict(otherItems, offer, config, added.key)) throw new Error('Your cart changed during the upgrade.');
        // The bundle is confirmed in the cart before touching the original line.
        cart = await request('cart/change.js', Object.assign({ id: source.key, quantity: 0 }, sectionContext));
        if (!tagged(cart) || hasSource(cart)) throw new Error('We could not confirm the completed upgrade.');
        return cart;
      } catch (error) {
        if (!attempted) throw error;
        var state;
        try { state = await request('cart.js'); }
        catch (_) { throw reviewError('Connection interrupted. Please review your cart before checkout; do not add the offer again yet.'); }
        var added = tagged(state);
        if (offer.mode === 'add') {
          if (added && added.quantity === 1 && Number(added.original_price) === offer.price && !conflict(state, offer.handle, config, added.key) && !roleConflict(state, offer, config, added.key)) return state;
          if (added && added.quantity === 1) {
            try { await request('cart/change.js', { id: added.key, quantity: 0 }); } catch (_) { /* Verify recovery. */ }
            try { state = await request('cart.js'); } catch (_) { throw reviewError('Please review your cart before checkout.'); }
            if (!tagged(state)) throw new Error('The offer changed during this addition. Please review the updated cart.');
          }
          if (!added) throw error;
          throw reviewError('The cart changed during this addition. Please review the quantities before checkout.');
        }
        var sourcePresent = hasSource(state);
        if (added && added.quantity === 1 && !sourcePresent) return state; // Remove succeeded but its response was lost.
        if (added && added.quantity === 1 && sourcePresent) {
          // Remove only this attempt's uniquely marked bundle; never another cart line.
          try { await request('cart/change.js', { id: added.key, quantity: 0 }); } catch (_) { /* Verify the outcome below. */ }
          try { state = await request('cart.js'); }
          catch (_) { throw reviewError('We could not verify the upgrade recovery. Please review your cart before checkout.'); }
          if (!tagged(state) && hasSource(state)) throw new Error('The upgrade could not finish. Your original item is still in the cart.');
        }
        if (!tagged(state) && hasSource(state)) throw error;
        throw reviewError('The upgrade was not fully confirmed. Please review your cart and quantities before checkout.');
      }
    };
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { createService: createService, configFrom: configFrom, represented: represented, eligible: eligible, conflict: conflict, roleConflict: roleConflict };
    return;
  }
  if (window.marayaCartOffersReady) return;
  window.marayaCartOffersReady = true;
  var busy = false;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  async function request(path, body) {
    var options = { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } };
    if (body) { options.method = 'POST'; options.headers['Content-Type'] = 'application/json'; options.body = JSON.stringify(body); }
    var controller = new AbortController();
    var timer = setTimeout(function () { controller.abort(); }, 15000);
    options.signal = controller.signal;
    try {
      var response = await fetch(root + path, options);
      var data = await response.json();
      if (!response.ok || data.status >= 400 || data.errors) {
        throw new Error(typeof data.description === 'string' ? data.description : 'This cart change could not be completed.');
      }
      return data;
    } finally { clearTimeout(timer); }
  }
  async function refreshDrawer(provided) {
    var sections = provided;
    if (!sections || !sections['cart-drawer'] || !sections['cart-count']) sections = await request('?sections=cart-drawer,cart-count');
    if (!sections['cart-drawer'] || !sections['cart-count']) throw new Error('Cart display could not refresh.');
    var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
    var countDoc = new DOMParser().parseFromString(sections['cart-count'], 'text/html');
    var ids = ['MinimogCartDrawerHeader', 'MinimogCartDrawerBody', 'MinimogCartDrawerFooter'];
    var pairs = ids.map(function (id) { return [document.getElementById(id), doc.getElementById(id)]; });
    if (pairs.some(function (p) { return !p[0] || !p[1]; })) throw new Error('Cart display could not refresh.');
    pairs.forEach(function (p) { p[0].innerHTML = p[1].innerHTML; });
    document.querySelectorAll('m-cart-count').forEach(function (c) { if (typeof c.onUpdate === 'function') c.onUpdate(countDoc); });
  }
  function feedback(message, error, mustReview) {
    var node = document.getElementById('mr-cart-feedback');
    if (!node) return;
    node.hidden = false;
    node.dataset.error = error ? 'true' : 'false';
    node.setAttribute('role', error ? 'alert' : 'status');
    node.textContent = message;
    if (mustReview) {
      var link = document.createElement('a'); link.href = root + 'cart'; link.textContent = ' Review cart'; node.appendChild(link);
      document.querySelectorAll('#MinimogCartDrawer [name="checkout"]').forEach(function (b) { b.disabled = true; });
    }
  }
  function lock() {
    var drawer = document.getElementById('MinimogCartDrawer');
    var states = [];
    if (!drawer) return states;
    drawer.setAttribute('aria-busy', 'true');
    document.documentElement.classList.add('mr-cart-transaction');
    drawer.querySelectorAll('button:not(.m-cart-drawer__close), input, textarea, select').forEach(function (e) {
      states.push([e, e.disabled]); e.disabled = true;
    });
    return states;
  }
  function unlock(states) {
    states.forEach(function (p) { if (p[0].isConnected) p[0].disabled = p[1]; });
    document.documentElement.classList.remove('mr-cart-transaction');
    var drawer = document.getElementById('MinimogCartDrawer');
    if (drawer) drawer.removeAttribute('aria-busy');
  }
  document.addEventListener('submit', function (event) {
    if (busy && event.target.closest('#MinimogCartDrawer')) { event.preventDefault(); event.stopImmediatePropagation(); }
  }, true);
  document.addEventListener('click', async function (event) {
    if (busy) {
      if (event.target.closest('[data-mr-cart-action], .m-cart-item__remove, m-cart-remove-button, m-quantity-input, button[name="checkout"], button[name="add"], .m-add-to-cart')) {
        event.preventDefault(); event.stopImmediatePropagation();
      }
      return;
    }
    var button = event.target.closest('[data-mr-cart-action]');
    if (!button || !button.closest('#MinimogCartDrawer')) return;
    event.preventDefault();
    var block = button.closest('.mr-cart-offer');
    var offer = { mode: button.dataset.mrCartAction, id: Number(button.dataset.targetId), handle: button.dataset.targetHandle,
      price: Number(button.dataset.targetPrice), currency: button.dataset.cartCurrency, sourceKey: button.dataset.sourceKey,
      sourceId: Number(button.dataset.sourceId), sourcePrice: Number(button.dataset.sourcePrice) };
    var rawConfig;
    try { rawConfig = JSON.parse(block.querySelector('[data-mr-cart-config]').textContent); }
    catch (_) { feedback('Please refresh the page before using this offer.', true, false); return; }
    busy = true;
    var states = lock();
    var label = button.textContent;
    button.textContent = offer.mode === 'upgrade' ? 'Updating your duo…' : 'Adding…';
    var token = window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() : Date.now() + '-' + Math.random().toString(36).slice(2);
    var message = '', failed = false, mustReview = false, cart;
    try {
      cart = await createService(request, rawConfig, { sectionUrl: window.location.pathname })(offer, token);
      await refreshDrawer(cart.sections);
      message = offer.mode === 'upgrade' ? 'Upgraded to your duo. The original item was replaced.' : 'Added to your ritual. Your total is updated below.';
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      document.dispatchEvent(new CustomEvent('mr:cro', { detail: { action: offer.mode === 'upgrade' ? 'cart_bundle_upgrade' : 'cart_recommendation_add', recommendation_handle: offer.handle } }));
    } catch (error) {
      failed = true; mustReview = !!error.review;
      message = error.message || 'The cart could not be updated. Please try again.';
      try { await refreshDrawer(); }
      catch (_) { mustReview = true; message = 'Your cart display could not refresh. Please review the cart before checkout.'; }
    } finally {
      busy = false; unlock(states);
      if (button.isConnected) button.textContent = label;
    }
    feedback(message, failed, mustReview);
  }, true);
})();
